import type {
	EditorViewModePluginOptions,
	ViewMode,
} from '@atlaskit/editor-plugin-editor-viewmode';
import { editorExperiment } from '@atlaskit/tmp-editor-statsig/experiments';

interface Props {
	options: {
		viewMode: ViewMode | undefined;
		hasEditPermission: boolean;
		__livePage: boolean;
	};
}

export function editorViewModePluginOptions({ options }: Props): EditorViewModePluginOptions {
	return editorExperiment('live_pages_graceful_edit', 'control')
		? {
				// SECTION: From confluence/next/packages/editor-presets/src/full-page/createFullPageEditorPreset.ts `.add(['editorViewModePlugin', ...])`
				mode: options.viewMode,
				// END SECTION
			}
		: {
				// SECTION: From confluence/next/packages/editor-presets/src/full-page/useFullPageEditorPreset.ts `const presetOptions.initialPluginConfiguration.viewModePlugin`
				initialContentMode: options.__livePage
					? options.hasEditPermission
						? 'live-edit'
						: 'live-view-only'
					: 'edit',
				// END SECTION
			};
}
